import type { PropsWithChildren } from 'react';

import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { settingsButton } from '@tma.js/sdk-react';

import { Routes } from 'src/shared/model/routes';

export function PageStructure({ children }: PropsWithChildren) {
  const navigate = useNavigate();

  useEffect(() => {
    settingsButton.show.ifAvailable();
    const off = settingsButton.onClick.ifAvailable(() => {
      navigate(Routes.Settings);
    });

    return () => {
      if (typeof off === 'function') {
        (off as () => void)();
        return;
      }

      if (
        off &&
        typeof off === 'object' &&
        'destroy' in off &&
        typeof (off as { destroy: () => void }).destroy === 'function'
      ) {
        (off as { destroy: () => void }).destroy();
      }
    };
  }, [navigate]);

  return <>{children}</>;
}
